































































































































































































import Vue from 'vue'
import { UserServiceProxy } from '@/service-proxies/app-v2/user.service-proxies'
import { MasterlinkRoleServiceProxy } from '@/service-proxies/app-v2/system.service-proxies'
import dayjs from 'dayjs'
import { getUserInfo } from '@/utils/auth'
const formItemLayout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 16 }
}
const masterlinkroleservice = new MasterlinkRoleServiceProxy()
const UserService = new UserServiceProxy()
export default Vue.extend ({
  name: '',
  props:{
    title:{
      type: String,
      default: 'page_user_management_new_user'
    },
    visible:{
      type: Boolean,
      default: false
    },
    canedit:{
      type: Boolean,
      default: true
    },
    treeData:{
      type: Array,
      default: () => []
    },
    organizeData:{
      type: Array,
      default: () => []
    },
    positionData:{
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      formItemLayout,
      form: this.$form.createForm(this),
      departmentList: [], // 部门列表
      value: [],
      roleList: [],
      confirmDirty: false,
    }
  },
  watch: {
    visible:{
      handler(){
        if(this.visible){
          masterlinkroleservice.getRoles(undefined,undefined).then((res: any) => {
            if(res.data){
              this.roleList = res.data.roleVOList
            }
          })
        }
      }
    }
  },
  methods: {
    cancel(){
      this.form.resetFields()
      this.$emit('closemodal',false)
    },
    selectDept(e: any, node, extra){
      console.log(e, node, extra)
      this.value = extra.halfCheckedKeys
    },
    onSubmit() {
      this.form.validateFields((err: any,values: any) => {
        if (!err) {
          const user = getUserInfo()
          const tenantId = user.tenant_id
          const deptIds = []
          values.deptId.forEach(element => {
            console.log(9999,element)
            deptIds.push(element)
          });
          console.log(values.organizationId)
          const param: any = {
            tenantId: tenantId,
            account: values.account,
            password: values.defaultpas,
            name: values.name,
            realName: values.realName,
            roleId: values.roleId ? values.roleId.join(',') : '',
            organizationId: values.organizationId ? values.organizationId.join(',') : '',
            postId: values.postId ? values.postId.join(',') : '',
            deptId: deptIds.toString(),
            phone: values.phone,
            email: values.email,
            sex: values.sex,
            birthday: values.birthday ? dayjs(Number(values.birthday)).format('YYYY-MM-DD HH:mm:ss') : undefined,
          }
          UserService.submit(param).then(res =>{
            this.form.resetFields()
            this.$message.success(this.$t('page_user_management_new_success'))
            this.$emit('closemodal', true)
          })
        }
      })
    },
    handleConfirmBlur(e: any) {
      const value = e.target.value;
      this.confirmDirty = this.confirmDirty || !!value;
    },
    compareToFirstPassword(rule: any, value: any, callback: any) {
      const form = this.form;
      if (value && value !== form.getFieldValue('defaultpas')) {
        callback(this.$t('page_user_management_same_password_twice'))
      } else {
        callback();
      }
    },
    validateToNextPassword(rule: any, value: any, callback: any) {
      const form = this.form;
      const regex1 = new RegExp('(?=.*[0-9])(?=.*[A-Z])')
      const regex2 = new RegExp('(?=.*[0-9])(?=.*[a-z])')
      const regex3 = new RegExp('(?=.*[0-9])(?=.*[^a-zA-Z0-9])')
      const regex4 = new RegExp('(?=.*[A-Z])(?=.*[a-z])')
      const regex5 = new RegExp('(?=.*[A-Z])(?=.*[^a-zA-Z0-9])')
      const regex6 = new RegExp('(?=.*[a-z])(?=.*[^a-zA-Z0-9])')
      if (
        !regex1.test(value) &&
        !regex2.test(value) &&
        !regex3.test(value) &&
        !regex4.test(value) &&
        !regex5.test(value) &&
        !regex6.test(value)
      ) {
        callback(this.$t('page_user_management_special_characters'))
      }
      if (value && this.confirmDirty) {
        form.validateFields(['confirm'], { force: true });
      }
      callback();
    },
  }
})
